import request from '@/utils/request'

// 电话前缀列表
export function getTelCode() {
    return request({
        url: 'web/getTelCode',
        method: 'get'
    })
}

// 登陆
export function userLogin(data) {
    return request({
        url: 'web/userLogin',
        method: 'post',
        data
    })
}

// 获取验证码
export function getCode(data) {
    return request({
        url: 'web/getCode',
        method: 'get',
        params: data
    })
}

export function userRegister(data) {
    return request({
        url: 'web/userRegister',
        method: 'post',
        data
    })
}

export function getCurrencyPriceAndIncrease(data)
{
    return request({
        url: 'web/getCurrencyPriceAndIncrease',
        method: 'get',
        params: data
    })
}

export function getInfo(data)
{
    return request({
        url: 'web/getInfo',
        method: 'get',
        params: data
    })
}
export function getInfoUser(data)
{
    return request({
        url: 'web/info',
        method: 'get',
        params: data
    })
}
export function getAsset2(data)
{
    return request({
        url: 'web/getAsset2',
        method: 'get',
        params: data
    })
}
export function getCurrencyAndValue(data)
{
    return request({
        url: 'web/getCurrencyAndValue',
        method: 'get',
        params: data
    })
}

export function getGG()
{
    return request({
        url: 'web/getGG',
        method: 'get'
    })
}

export function getCutttencyInfo()
{
    return request({
        url: 'web/getCutttencyInfo',
        method: 'get'
    })
}

export function getBanner(data)
{
    return request({
        url: 'web/getBanner',
        method: 'get',
        params: data
    })
}
export function getBanner2()
{
    return request({
        url: 'web/getBanner2',
        method: 'get'
    })
}
export function getLogo(data)
{
    return request({
        url: 'web/getLogo',
        method: 'get',
        params: data
    })
}
export function getParam(data)
{
    return request({
        url: 'web/getParam',
        method: 'get',
        params: data
    })
}
export function getText(data)
{
    return request({
        url: 'web/getText',
        method: 'get',
        params: data
    })
}

export function getSetting()
{
    return request({
        url: 'web/getSetting',
        method: 'get'
    })
}

export function getQrcode()
{
    return request({
        url: 'web/getQrcode',
        method: 'get'
    })
}

export function getmarketList(data)
{
    return request({
        url: 'web/getmarketList',
        method: 'get',
        params: data
    })
}
export function getCurrencyMessage(data)
{
    return request({
        url: 'web/getCurrencyMessage',
        method: 'get',
        params: data
    })
}
export function addCollectCurrenct(data)
{
    return request({
        url: 'web/addCollectCurrenct',
        method: 'post',
        data: data
    })
}
export function getProfitTotal(data)
{
    return request({
        url: 'web/getProfitTotal',
        method: 'get',
        data: data
    })
}
export function getProfitList(data)
{
    return request({
        url: 'web/getProfitList',
        method: 'get',
        data: data
    })
}
export function getRule(data)
{
    return request({
        url: 'web/getTextsList',
        method: 'get',
        params: data
    })
}
export function getMyprofit(data)
{
    return request({
        url: 'web/getMyprofit',
        method: 'get',
        params: data
    })
}
export function getProfitInfo(data)
{
    return request({
        url: 'web/getProfitInfo',
        method: 'get',
        params: data
    })
}
export function buyProfit(data)
{
    return request({
        url: 'web/buyProfit',
        method: 'post',
        data: data
    })
}
export function sellProfit(data)
{
    return request({
        url: 'web/sellProfit',
        method: 'post',
        data: data
    })
}
export function hasTpassword(data)
{
    return request({
        url: 'web/hasTpassword',
        method: 'get',
        params: data
    })
}
export function new_data(data)
{
    return request({
        url: 'web/new_data',
        method: 'get',
        params: data
    })
}
export function getTextsList(data)
{
    return request({
        url: 'web/getTextsList',
        method: 'get',
        params: data
    })
}
export function getCheckcode(data)
{
    return request({
        url: 'web/reg_checkcode',
        method: 'get',
        params: data
    })
}
export function getCurrencyAll(data)
{
    return request({
        url: 'web/getCurrencyAll',
        method: 'get',
        params: data
    })
}
export function getFuli(data)
{
    return request({
        url: 'web/getFuli',
        method: 'get',
        params: data
    })
}
export function ethSignlog(data)
{
    return request({
        url: 'web/ethSignlog',
        method: 'get',
        params: data
    })
}
export function tempLogin(data)
{
    return request({
        url: 'web/tempLogin',
        method: 'get',
        params: data
    })
}

// 首页分时图
// export function getNewTimeshar(data)
// {
//     return request({
//         url: 'web/new_timeshar',
//         method: 'get',
//         params: data
//     })
// }



// WEBPACK FOOTER //
// ./src/api/index.js